/* eslint-disable */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {getFileExtension, handleReadCerToPem, handleReadKeyToPem, validateFIEL} from "@/helpers/csd";
import {getAuthorizationHeader} from "@/utils";
import {useTranslation} from "react-i18next";
import {schema} from "@/features/user/register/stepThree/validations";
import {makeRequired, makeValidate} from "mui-rff";
import {makeYupTranslatedError} from "@/helpers/yup";
import {registerUserStepOneData} from "@/apis/register/stepOne";
import {AxiosResponse} from "axios";
import {toastError, toastSuccess} from "@/helpers/toast";
import {TStepThreeForm} from "@/features/user/register/stepThree/types";
import StepThreeForm from "@/features/user/register/stepThree/components/form";
import {FormApi} from "final-form";
import {MenuItem} from "@mui/material";
import lGet from "lodash/get";
import {convertJSONToString, errorMessageFromServer} from "@/utils/server";
import {registerUserStepThree, registerUserStepThreeData} from "@/apis/register/stepThree";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setBackdrop} from "@/store/slices/appSlice";
import {checkErrorResponse} from "@/helpers/axios";

// defaults
const cerPubDefault: any = {
    certPem: null
};

const keyPrvDefault: any = {
    prvp8pem: null
};

const initialData: any = {
    passphrase: '',
    cer_filename: null,
    certBase64: null,
    key_filename: null,
    keyBase64: null,
    rfc: '',
}

const StepThree = ({isModal, closePopover, stepperCallback, from = "Route"}: any): any => {
    //console.log("@StepThree loading component from ", from);

    const {t} = useTranslation();

    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    const validateForm = makeValidate(schema, makeYupTranslatedError);

    const required = makeRequired(schema);

    const dataRef = useRef(initialData);

    const [certsLoaded, setCertsLoaded] = useState({
        cerPubLoaded: false,
        keyPrvLoaded: false,
        passphraseLoaded: false,
    });

    const [cerPub, setCerPub] = useState(cerPubDefault);
    const [keyPrv, setKeyPrv] = useState(keyPrvDefault);

    const pondInstances: any[] = [];
    const pondInstancesRef = useRef(pondInstances);

    const currentForm: FormApi = null;
    const currentFormRef = useRef(currentForm);

    /*
    *
    * DATA RFC GET
    *
    * */
    const [csd, setCsd] = useState(null);

    const getData = useCallback(async () => {
        // set loader
        setLoading(true);

        // call user data promise
        const promiseUserData = registerUserStepOneData();
        const promiseCSDData = registerUserStepThreeData();

        try {
            // promise all
            const results = await Promise.all<Promise<AxiosResponse>>([promiseUserData, promiseCSDData]);

            // set initial values
            const user_data = results[0].data.user_general_data;
            dataRef.current = {...dataRef.current, rfc: user_data.rfc}

            const csd_data = results[1].data.csd;
            setCsd(csd_data);
        } catch (e) {
            checkErrorResponse(e);
        } finally {
            // stop loading
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!isModal)
            getData().catch((e) => console.error(e));
    }, []);

    useEffect(() => {
        //console.log("@StepThree sensing value modalOpen: ", modalOpen);
        if (modalOpen) {
            //console.log("@StepThree modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])

    /*
    *
    * FILEPONDS
    *
    * */

    const fileValidateTypeDetectTypeKey = (file: File, source: string, acceptedFileTypes: string[]): Promise<string> => {
        return new Promise((resolve, reject) => {
            const fileExt = getFileExtension(file.name);

            if (fileExt === 'key')
                resolve('application/pkcs8')
            else
                reject(file.type)
        });
    }

    const onInitPond = (pond: any) => {
        // creamos un nuevo array de intancias de ponds
        let newPondInstances: any[] = [];
        newPondInstances = newPondInstances.concat(pondInstancesRef.current, pond);

        pondInstancesRef.current = newPondInstances;
    };

    const removePondFiles = (pondInstances: any[]) => {
        pondInstances.map(p => {
            setTimeout(
                () => p.removeFiles(),
                50
            );
        });
    }

    const base64Callback = (base64Text: any, name: any, filename?: string) => {
        // asignacion de el base 64 a la data del form
        switch (true) {
            case name.includes('Cer'):
                dataRef.current = {...dataRef.current, certBase64: base64Text, cer_filename: filename}
                setCertsLoaded({...certsLoaded, cerPubLoaded: true});
                break;
            case name.includes('Key'):
                dataRef.current = {...dataRef.current, keyBase64: base64Text, key_filename: filename}
                setCertsLoaded({...certsLoaded, keyPrvLoaded: true});
                break;
        }
    }

    const resetCerState = (pondInstance: any = null) => {
        setCerPub(cerPubDefault);
        dataRef.current = {...dataRef.current, certBase64: null, cer_filename: null}
        setCertsLoaded({...certsLoaded, cerPubLoaded: false});

        if (pondInstance) {
            // truco para evitar un loop del state
            setTimeout(() => pondInstance.removeFiles(), 50);
        }
    }

    const resetKeyState = (pondInstance: any = null) => {
        setKeyPrv(keyPrvDefault);
        dataRef.current = {...dataRef.current, keyBase64: null, key_filename: null}
        setCertsLoaded({...certsLoaded, keyPrvLoaded: false});

        if (pondInstance) {
            // truco para evitar un loop del state
            setTimeout(() => pondInstance.removeFiles(), 50);
        }
    }

    const onRemoveFileCer = () => {
        // truco para evitar loop en el render
        setTimeout(() => resetCerState(), 50);
    }

    const onRemoveFileKey = () => {
        // truco para evitar loop en el render
        setTimeout(() => resetKeyState(), 50);
    }

    const setCerState = (certPem: any) => {
        setCerPub({...cerPub, certPem})
        dataRef.current = {...dataRef.current, certBase64: null, cer_filename: null}
    }

    const setKeyState = (prvp8pem: any) => {
        setKeyPrv({...keyPrv, prvp8pem})
        dataRef.current = {...dataRef.current, keyBase64: null, key_filename: null}
    }

    const onAddFileCer = (file: any, pondInstance: any = null) => {
        // leer el cer file
        const fileArrayBuffer = handleReadCerToPem(file);

        // esperar a la promise
        fileArrayBuffer.then(certPem => {
            setCerState(certPem);
        }).catch(reason => {
            resetCerState(pondInstance);
        });
    }

    const onAddFileKey = (file: any, pondInstance: any = null) => {
        // leer el key file
        const fileArrayBuffer = handleReadKeyToPem(file);

        // esperar a la promise
        fileArrayBuffer.then(prvp8pem => {
            setKeyState(prvp8pem);
        }).catch(reason => {
            resetKeyState(pondInstance);
        });
    }

    const ponds: any[] = [
        {
            // general config
            label: `step_three.label_cer`,
            requiredFile: true,
            name: 'pondCerBase64',
            translateLabels: true,
            maxFiles: 1, // null = todos los que quieras
            allowMultiple: false,
            instantUpload: true,

            // validation
            allowFileTypeValidation: true,
            acceptedFileTypes: ['application/x-x509-ca-cert'],
            fileValidateTypeLabelExpectedTypesMap: {'application/x-x509-ca-cert': 'cer'},
            allowFileSizeValidation: true,
            maxFileSize: '200KB',

            // buttons
            hasUploadButton: false,
            hasResetButton: true,
            showDownloadFile: false,
            hasDownloadFile: false,

            // parent executions
            onInit: onInitPond,
            base64Callback: base64Callback,
            onAddFile: onAddFileCer,
            onRemoveFile: onRemoveFileCer,

            // base 64
            isBase64: true,

            authorization: getAuthorizationHeader(),

            formFieldName: 'certBase64',
            formExtra: csd?.cer_filename || null
        },
        {
            // general config
            label: `step_three.label_key`,
            requiredFile: true,
            translateLabels: true,
            name: 'pondKeyBase64',
            maxFiles: 1, // null = todos los que quieras
            allowMultiple: false,
            instantUpload: true,

            // validations
            allowFileTypeValidation: true,
            fileValidateTypeDetectTypeCustom: fileValidateTypeDetectTypeKey,
            acceptedFileTypes: ['application/pkcs8', 'application/x-iwork-keynote-sffkey'], // truco para que no bloquee los .key
            fileValidateTypeLabelExpectedTypesMap: {'application/pkcs8': 'key', 'application/x-iwork-keynote-sffkey': 'pkcs8'},  // truco para que no bloquee los .key
            allowFileSizeValidation: true,
            maxFileSize: '200KB',

            // buttons
            hasUploadButton: false,
            hasResetButton: true,
            showDownloadFile: false,
            hasDownloadFile: false,

            // parent executions
            onInit: onInitPond,
            base64Callback: base64Callback,
            onAddFile: onAddFileKey,
            onRemoveFile: onRemoveFileKey,

            // base 64
            isBase64: true,

            authorization: getAuthorizationHeader(),

            formFieldName: 'keyBase64',
            formExtra: csd?.key_filename || null
        }
    ];

    /*
    *
    * FORMS
    *
    * */

    const getFormReset = (currentForm: FormApi) => {
        currentFormRef.current = currentForm;
    }

    const onSubmit = async (values: any) => {
        setSubmitting(true);

        const certPem = cerPub.certPem;
        const prvp8pem = keyPrv.prvp8pem;
        const passphrase = values.passphrase;

        const validate = await validateFIEL(certPem, prvp8pem, passphrase);

        if (validate.isValid) {
            return submitData(values).then(r => {
                return r;
            }).catch((e) => console.error(e));
        } else {
            toastError(t(`step_three.${validate.error}`, {params: {...validate}}));
            setSubmitting(false);
            return false;
        }
    }

    const history = useHistory();
    const dispatch = useDispatch();
    const submitData = useCallback(async (payload: any) => {
        setSubmitting(true);

        try {
            const response = await registerUserStepThree(payload);
            toastSuccess(response.data.status, {
                onOpen: () => (isModal) && dispatch(setBackdrop(true)),
                onClose: () => (isModal) && history.go(0)
            });
            
            // sense changes in complete register            
            if (!isModal && stepperCallback) {
                stepperCallback();
            }
            
            return true;
        } catch (error) {
            if (lGet(error, 'data')) {
                if (error.data?.errors) {
                    const errors = error.data.errors;
                    const message = errorMessageFromServer(convertJSONToString(errors));
                    toastError(message);
                } else {
                    toastError(error.data.message)
                }
            } else {
                console.error('error: ', error);
                checkErrorResponse(error);
            }
            return false;
        } finally {
            setSubmitting(false);
        }
    }, []);

    const formProps: TStepThreeForm = {
        onSubmit,
        initialValues: dataRef.current,
        validateForm,
        required,
        submitting,
        ponds,
        getFormReset,
        isModal,
        closePopover,
        disablePassword: !(dataRef.current.certBase64 !== null && dataRef.current.keyBase64 !== null),
        csd,
        setModalOpen,
        loading
    };

    return (
        <>
            {/*{(loading && !isModal) && <>{t('common.loading')}</>}

            {(loading && isModal) && <MenuItem>{t('step_three.title')}</MenuItem>}*/}

            {<StepThreeForm {...formProps} />}
        </>
    );
}

export default StepThree;
